import React from "react";
import { Button as AntButton } from 'antd';
import { ButtonColorType, ButtonHTMLType, ButtonType, ButtonVariantType } from "antd/es/button/buttonHelpers";
import './style.scss';

interface ButtonProps {
    key?: any;
    onClick?: any;
    ghost?: boolean;
    block?: boolean;
    danger?: boolean;
    type?: ButtonType;
    className?: string;
    icon?: React.ReactNode;
    color?: ButtonColorType;
    htmlType?: ButtonHTMLType;
    children?: React.ReactNode;
    variant?: ButtonVariantType;
    style?: React.CSSProperties;
    loading?: boolean | {
        delay?: number;
        icon?: React.ReactNode;
    };
    disabled?: boolean;
}

const Button = (props: ButtonProps) => {
    const { style, className, type, loading, onClick, color, variant, ghost, block, children, danger, icon, disabled } = props;
    return (
        <AntButton
            type={type}
            icon={icon}
            color={color}
            style={style}
            ghost={ghost}
            block={block}
            danger={danger}
            variant={variant}
            onClick={onClick}
            loading={loading}
            disabled={disabled}
            className={className ? className : 'button-styles'}
        >
            {children}
        </AntButton>
    );
};
export default Button;